/*
 * Name: Popup.js
 * Description: Show pop-up `data-popup-id` once or multiple times based on `data-popup-times`
 * Version: v1.0.0
 */

// window.g_dev = true;

let popupElements = document.querySelectorAll('[data-popup]');

if (popupElements.length) {
    [].forEach.call(popupElements, function (popupElement) {

        // Set variables
        let popupInclude = popupElement.getAttribute('data-popup-include');
        let popupExclude = popupElement.getAttribute('data-popup-exclude');
        let popupTimes = popupElement.getAttribute('data-popup-times');
        let popupId = popupElement.getAttribute('data-popup-id');
        let popupDelay = popupElement.getAttribute('data-popup-delay');
        let popupAutohide = popupElement.getAttribute('data-popup-autohide');

        function showPopup() {
            popupElement.classList.add('active');
            popupElement.parentElement.classList.add('active');
        }

        // Run script on pages
        if(popupInclude !== '') {
            let element = document.querySelector('body.page-'+popupInclude);
            if(typeof(element) !== 'undefined' && element !== null) {

            } else {
                return false;
            }
        }

        // Check `data-popup-times`
        if (popupTimes !== '') {

            if(popupTimes === 'once') {
                if(sessionStorage.getItem(popupId) === null) {
                    showPopup();
                }
            } else {
                // Show popup when count is less or the same as `data-popup-times`
                if (sessionStorage.getItem(popupId) <= popupTimes) {
                    popupElement.classList.add('active');
                    popupElement.parentElement.classList.add('active');

                    sessionStorage.setItem(popupId,
                        (parseInt(sessionStorage.getItem(popupId), 10) + 1).toString(10)
                    );
                }
            }

            // Start count when empty
            if(sessionStorage.getItem(popupId) === null) {
                sessionStorage.setItem(popupId, '1');
            } else {
                sessionStorage.setItem(popupId,
                    (parseInt(sessionStorage.getItem(popupId), 10) + 1).toString(10)
                );
            }

            // Always show popup
        } else {
            if(popupDelay) {
                setTimeout(function() {
                    popupElement.classList.add('active');
                    popupElement.parentElement.classList.add('active');
                }, popupDelay);
            } else {
                popupElement.classList.add('active');
                popupElement.parentElement.classList.add('active');
            }
        }

        // Auto hide popup
        if (popupAutohide !== '') {

            const options = {
                attributes: true
            }

            function callback(mutationList, observer) {
                mutationList.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (mutation.target.classList.contains('active')) {
                            if (popupAutohide !== '') {
                                setTimeout(function () {
                                    if (popupElement.contains(document.activeElement) === false) {
                                        popupElement.classList.remove('active');
                                        popupElement.parentElement.classList.remove('active');
                                    }
                                }, popupAutohide);
                            }
                        }
                    }
                })
            }

            const observer = new MutationObserver(callback)
            observer.observe(popupElement, options)
        }

        // Debug
        if(window.g_dev === true) {
            console.log(sessionStorage.getItem(popupId));
        }

    });
}
